export const CRUISE_TYPES = ['Sunset Cruise', 'Sundown Cruise', 'Dinner Cruise'];

export const CRUISE_DECKS = {
  'Sunset Cruise': ['Upper Deck', 'Middle Deck'],
  'Sundown Cruise': ['Upper Deck', 'Middle Deck'],
  'Dinner Cruise': ['Middle Deck'],
};

export const DECK_CAPACITY = {
  'Upper Deck': 60,
  'Middle Deck': 90,
};

export const PAYMENT_MODES = ['Razorpay', 'Cash', 'ICICI POS', 'Bank Transfer', 'GPay'];

export const CAPACITY_SLOTS = [
  { cruise: 'Sunset Cruise', deck: 'Upper Deck', max: 60 },
  { cruise: 'Sunset Cruise', deck: 'Middle Deck', max: 90 },
  { cruise: 'Sundown Cruise', deck: 'Upper Deck', max: 60 },
  { cruise: 'Sundown Cruise', deck: 'Middle Deck', max: 90 },
  { cruise: 'Dinner Cruise', deck: 'Middle Deck', max: 90 },
];

export const TAC_RATE = 0.1;

// Colors
//
// The single source of truth for design tokens is src/styles/tokens.css (:root
// CSS custom properties). The literal hex constants below are kept BYTE-IDENTICAL
// because some code paths (jsPDF / exceljs / canvas) need raw hex, where a
// var(--token) string would be invalid. They mirror the token values exactly.
export const NAVY = '#0A1628';
export const GOLD = '#C9A84C';
export const GOLD_LIGHT = '#F5E6B8';
export const AMBER = '#D97706';
export const AMBER_LIGHT = '#FEF3C7';

// JS access to the CSS variables in src/styles/tokens.css. Use these in inline
// styles and shared components (e.g. style={{ color: tokens.accent }}). They
// resolve to the same current values as the literals above, so adopting them is
// a no-op visually. Do NOT pass these var() strings to jsPDF/exceljs/canvas —
// use the raw-hex constants above for those.
export const tokens = {
  // surfaces
  canvas:          'var(--color-canvas)',
  surface:         'var(--color-surface)',
  sunken:          'var(--color-sunken)',
  // borders
  borderSubtle:    'var(--color-border-subtle)',
  border:          'var(--color-border)',
  borderStrong:    'var(--color-border-strong)',
  // ink
  ink:             'var(--color-ink)',
  inkSecondary:    'var(--color-ink-secondary)',
  inkMuted:        'var(--color-ink-muted)',
  inkFaint:        'var(--color-ink-faint)',
  inkNeutral:      'var(--color-ink-neutral)',
  inkBrand:        'var(--color-ink-brand)',
  inkBrandSoft:    'var(--color-ink-brand-soft)',
  inkBrandSofter:  'var(--color-ink-brand-softer)',
  // accent
  accent:          'var(--color-accent)',
  accentStrong:    'var(--color-accent-strong)',
  accentLight:     'var(--color-accent-light)',
  accentRing:      'var(--color-accent-ring)',
  accentShadow:    'var(--color-accent-shadow)',
  // semantic
  success:         'var(--color-success)',
  successStrong:   'var(--color-success-strong)',
  successBg:       'var(--color-success-bg)',
  successBorder:   'var(--color-success-border)',
  warning:         'var(--color-warning)',
  warningStrong:   'var(--color-warning-strong)',
  warningAmber:    'var(--color-warning-amber)',
  warningBg:       'var(--color-warning-bg)',
  warningBgSoft:   'var(--color-warning-bg-soft)',
  warningBorder:   'var(--color-warning-border)',
  danger:          'var(--color-danger)',
  dangerStrong:    'var(--color-danger-strong)',
  dangerBg:        'var(--color-danger-bg)',
  dangerBorder:    'var(--color-danger-border)',
  info:            'var(--color-info)',
  infoSoft:        'var(--color-info-soft)',
  // radii
  radiusSm:        'var(--radius-sm)',
  radiusMd:        'var(--radius-md)',
  radiusLg:        'var(--radius-lg)',
  radiusMark:      'var(--radius-mark)',
  radiusPill:      'var(--radius-pill)',
  // shadows
  shadowCard:      'var(--shadow-card)',
  shadowAccent:    'var(--shadow-accent)',
};

// Per-cruise color palette — index matches sort_order (0-based) in cruise_settings.
// Each entry has tracker colors (header, booking, tracker) and card colors (leftBorder, bg, border).
export const CRUISE_COLOR_PALETTE = [
  { header: '#D4820A', booking: '#A86408', tracker: '#7A4A05', leftBorder: '#f97316', bg: '#fff8f4', border: '#fed7aa' },
  { header: '#0A7B8C', booking: '#086270', tracker: '#064D5A', leftBorder: '#0ea5e9', bg: '#f0f9ff', border: '#bae6fd' },
  { header: '#6D3AB5', booking: '#4F2785', tracker: '#321655', leftBorder: '#8b5cf6', bg: '#faf5ff', border: '#ddd6fe' },
  { header: '#2E7B4F', booking: '#1E5C39', tracker: '#0F3D24', leftBorder: '#10b981', bg: '#f0fdf4', border: '#a7f3d0' },
  { header: '#C9184A', booking: '#9B1231', tracker: '#6B0C21', leftBorder: '#f43f5e', bg: '#fff1f2', border: '#fecdd3' },
];
